<template lang="pug">
.has-tip(tabindex="0" @focus="showTooltip" @blur="hideTooltip" :open="open")
  .tooltip(:class="direction")
    p {{content}}
  slot
</template>

<script>
export default {
  data: () => {
    return {
      open: false
    }
  },
  props: {
    direction: {
      default: 'top'
    },
    content: {
      default: ''
    }
  },
  methods: {
    showTooltip () {
      this.open = true
    },
    hideTooltip () {
      this.open = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Tooltip.vue